import React, { useMemo } from 'react';
import { pick, pipe, intersection, union, prop } from 'ramda';
import {
    usePortletDispatch,
    usePortletSelector,
    usePortletTranslations
} from 'js/components/system/Portlet';
import { MultiSelect } from 'js/components/common/Fields/MultiSelect';
import { CATEGORY_TYPE } from 'js/components/main/Games/constants';
import { setFilterProvidersAction } from '../actions';
import { filterByEmptyGames, filterByFeatures, filterByVolatility } from '../filters';
import { useGameFeaturesSelector } from 'js/store/hooks/useGameFeaturesSelector';

export const Providers = ({ listOfProviders }) => {
    const features = useGameFeaturesSelector(prop('gameFeatures'));
    const PROVIDERS_TYPES = listOfProviders.trim().split(',')
        .filter(el => el !== '')
        .map(el => el.trim());
    const {
        categories,
        filters: { selectedCategories, selectedProviders, selectedFeatures, selectedVolatility }
    } = usePortletSelector(pick(['categories', 'filters']));
    const t = usePortletTranslations();
    const dispatch = usePortletDispatch();

    const filteredCategories = useMemo(
        () => pipe(
            filterByFeatures(selectedFeatures, features),
            filterByVolatility(selectedVolatility, features),
            filterByEmptyGames
        )(categories),
        [features, categories, selectedFeatures, selectedVolatility]
    );

    const count = {};
    const currentCategories = selectedCategories.length === 0
        ? filteredCategories
        : filteredCategories.filter(cat => selectedCategories.includes(cat.cid));
    const currentCategoriesFiltered = currentCategories
        .filter(({ cid }) => !(cid === CATEGORY_TYPE.FAVORITES || cid === CATEGORY_TYPE.RECENTLY));

    currentCategoriesFiltered.forEach((el) => {
        if (el.gameCodesWithProviders) {
            const providers = Object.keys(el.gameCodesWithProviders);
            providers.forEach((key) => {
                const val = el.gameCodesWithProviders[key] || [];
                const gameCodesCount = intersection(val, el.gameCodes);
                count[key] = count[key] || [];
                count[key] = union(count[key], gameCodesCount);
            });
        }
    });

    const options = PROVIDERS_TYPES.map(type => ({ id: type, label: type, hint: `(${count[type] ? count[type].length : 0})` }));

    const onChange = (selected) => {
        dispatch(setFilterProvidersAction(selected));
    };

    return (
        <MultiSelect
            label={t('gamesProviders')}
            options={options}
            selected={selectedProviders}
            onChange={onChange}
        />
    );
};

export default Providers;
